import Calendar from '@mui/icons-material/Event';
import { Chip, Stack } from '@mui/material';
import { DateRange, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import dayjs, { Dayjs } from 'dayjs';
import { dateUtils, localStorageUtils, SDK_CONSTANTS, TooltipComp } from 'fso-fincrime-sdk-ui';
import { useTranslation } from 'react-i18next';

import './DateFilter.scss';
import { IDateFilterProps } from '../../../ts/entities/chart/IFilter';

const DateFilter = ({
  setToDate,
  setFromDate,
  toDate,
  fromDate,
  chipClickHandle,
}: IDateFilterProps): JSX.Element => {
  const { t } = useTranslation();
  const dateFormat = localStorageUtils.getSavedItem(SDK_CONSTANTS.LOCAL_STORAGE_KEYS.DATE_FORMAT);

  const dateRangeChange = (value: DateRange<Dayjs>): void => {
    const v0 = value[0];
    if (v0) {
      setFromDate(v0.toDate()?.toString());
    }

    const v1 = value[1];
    if (v1) {
      setToDate(v1.toDate()?.toString());
    }
  };

  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const formattedDate = date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
    });
    return formattedDate;
  };

  return (
    <div className="date-range-option" data-testid="date-filter-chart">
      <TooltipComp
        label={`From: ${dateUtils.dateFormating(
          formatDate(dateUtils.getDateFormatedDateForDateTimePicker(fromDate ?? '') as string),
          dateFormat
        )} - To: ${dateUtils.dateFormating(
          formatDate(dateUtils.getDateFormatedDateForDateTimePicker(toDate ?? '') as string),
          dateFormat
        )}`}>
        <div>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateRangePicker
              value={[
                dayjs(dateUtils.getDateFormatedDateForDateTimePicker(fromDate ?? '')),
                dayjs(dateUtils.getDateFormatedDateForDateTimePicker(toDate ?? '')),
              ]}
              onChange={dateRangeChange}
              slots={{ field: SingleInputDateRangeField }}
              className="Datepicker-option"
              label={t('SELECT_DATE')}
              slotProps={{
                textField: { InputProps: { endAdornment: <Calendar /> }, size: 'small' },
              }}
              format={dateFormat}
            />
          </LocalizationProvider>
        </div>
      </TooltipComp>
      <Stack direction="row" spacing={1} className="shortcut-option">
        {SDK_CONSTANTS.DATES.DATE_SHORTCUTS.map((date) => (
          <Chip label={date.label} key={date.label} onClick={() => chipClickHandle(date.value)} />
        ))}
      </Stack>
    </div>
  );
};

export default DateFilter;
